export const cardFormReducer = (state, { type, payload }) => {
  switch (type) {
    case "UPDATE_FORM_FIELD":
      const { name, value } = payload;
      return {
        ...state,
        values: {
          ...state.values,
          [name]: value,
        },
      };
    case "SHOW_MEDIA_MODAL":
      return {
        ...state,
        showMediaModal: payload,
      };
    default:
      throw new Error(`${type} did not match any predefined cases.`);
  }
};



// WEBPACK FOOTER //
// ./src/core/admin/components/CardGrid/misc/card-form-reducer.js